import Mousetrap from "mousetrap";
import Vue from "vue";
import { fetchJSON, pollJSONUntil } from "../framework/api";
import * as Dialog from "../framework/dialog";
import { getParam } from "../framework/query";
import { getUITranslation } from "../utils/get_ui_translation";

let viewmodel = null;

/**
 * This function is used in the manual customer BPF page (manual_customer_bpf.html) to show or hide
 * configuration blocks depending on whether the price checkbox is checked.
 */
document.addEventListener("DOMContentLoaded", function () {
  if (!document.querySelector(".manual_customer_bpf")) {
    return;
  }
  var checkboxHours = document.getElementById("js-manual_customer_bpf_checkbox_hours_group");
  var checkboxPrice = document.getElementById("js-manual_customer_bpf_checkbox_price_group");
  var bpfHoursGroup = document.getElementById("js-manual_bpf_hours_group");
  var bpfHoursPriceFalse = document.getElementById("js-manual_bpf_hours_group_false");
  var bpfHoursPriceTrue = document.getElementById("js-manual_bpf_hours_group_true");

  function updateDisplayHours() {
    if (checkboxHours.checked) {
      bpfHoursGroup.style.display = "block";
    } else {
      bpfHoursGroup.style.display = "none";
    }
  }
  function updateDisplayPrice() {
    if (checkboxPrice.checked) {
      bpfHoursPriceTrue.style.display = "block";
      bpfHoursPriceFalse.style.display = "none";
    } else {
      bpfHoursPriceFalse.style.display = "block";
      bpfHoursPriceTrue.style.display = "none";
    }
  }

  checkboxHours.addEventListener("change", updateDisplayHours);
  checkboxPrice.addEventListener("change", updateDisplayPrice);
  updateDisplayPrice();
  updateDisplayHours();
});

/**
 * This script is used in any BPF report page.
 * For help popups
 * For printing the BPF
 * ...
 */
document.addEventListener("DOMContentLoaded", function () {
  if (!document.querySelector(".bpf-wrapper")) {
    return;
  }

  // use Mousetrap to bind the escape key to close the BPF popup hellper
  Mousetrap.bind("esc", function () {
    viewmodel.shown = false;
  });

  highlightBlankFields();

  viewmodel = new Vue({
    el: ".bpf-wrapper",
    data: {
      shown: false,
      method: null,
      isRefreshing: false,
      newBpfAvailable: false,
      hasChanges: false,
    },
    methods: {
      hide() {
        this.shown = false;
        if (this.hasChanges) {
          handleReloadPage();
        }
      },
      printBpf() {
        // To print the BPF, hide irrelevant elements, print the page, then restore the elements

        const styleEl = document.createElement("style");
        styleEl.innerHTML = `
          @media print {
            @page { margin: 0; }
            body { margin: 1cm; }
            .app-page__header,
            .explain-button,
            .bpf-wrapper > :not(.js-bpf-print-container) {
              display: none !important;
            }
          }
        `;
        document.head.appendChild(styleEl);

        window.print();

        styleEl.remove();
      },
      refreshBpf: handleRefreshBpf,
      reloadPage: handleReloadPage,
    },
  });

  window.vm = viewmodel;

  document.querySelectorAll(".bpf-wrapper .warning-sessions-list .js-check-bpf-warning").forEach(function (element) {
    element.addEventListener("click", handleCheckWarning);
  });

  document.querySelectorAll(".bpf-wrapper .warning-sessions-list .js-delete-bpf-warning").forEach(function (element) {
    element.addEventListener("click", handleDeleteWarning);
  });

  document.querySelectorAll(".bpf-wrapper .invalid-sessions-list .js-check-bpf-warning").forEach(function (element) {
    element.addEventListener("click", handleCheckWarning);
  });

  document.querySelectorAll(".bpf-wrapper .invalid-sessions-list .js-delete-bpf-warning").forEach(function (element) {
    element.addEventListener("click", handleDeleteWarning);
  });
});

async function handleRefreshBpf() {
  try {
    const el = document.querySelector("#refresh-bpf");
    const { refreshUrl, availableUrl, autoReload } = el.dataset;

    this.isRefreshing = true;

    const year = getParam("year", new Date().getFullYear());

    await fetchJSON(refreshUrl, {
      method: "POST",
      body: { year },
    });

    let url = new URL(availableUrl, window.location.origin);
    url.searchParams.append("year", year);
    await pollJSONUntil(({ available }) => available, url);

    this.newBpfAvailable = true;
    if (autoReload == "true") {
      location.reload();
    }
  } catch {
    Dialog.alertError(
      getUITranslation("Une erreur est survenue."),
      getUITranslation("Veuillez réessayer l'opération dans quelques minutes. Si le problème persiste, contactez-nous.")
    );
  } finally {
    this.isRefreshing = false;
  }
}

async function handleCheckWarning() {
  try {
    var id = this.getAttribute("name");
    var processWarningUrl = this.dataset.processWarningUrl;

    const year = getParam("year", new Date().getFullYear());
    const checked = $(this).is(":checked");
    const warning = { id: id, checked: checked };

    await fetchJSON(processWarningUrl, {
      method: "POST",
      body: {
        warning,
        year,
        process_type: "checked",
      },
    }).then(() => (viewmodel.hasChanges = true));
  } catch {
    Dialog.alertError(
      "Une erreur est survenue",
      "Veuillez réessayer l'opération dans quelques minutes. Si le problème persiste, contactez-nous."
    );
  }
}

async function handleDeleteWarning() {
  try {
    var id = this.getAttribute("id");
    var processWarningUrl = this.dataset.processWarningUrl;

    const year = getParam("year", new Date().getFullYear());

    const warning = { id: id, deleted: true };

    await fetchJSON(processWarningUrl, {
      method: "POST",
      body: {
        warning,
        year,
        process_type: "deleted",
      },
    }).then(() => {
      this.parentElement.parentElement.remove();
    });
  } catch {
    Dialog.alertError(
      "Une erreur est survenue",
      "Veuillez réessayer l'opération dans quelques minutes. Si le problème persiste, contactez-nous."
    );
  }
}

function handleReloadPage() {
  location.reload();
}

// Highlight blank fields in the BPF report (siret naf adresse etc)
function highlightBlankFields() {
  $(".field").each(function () {
    let $e = $(this);
    if ($e.html().trim().length == 0) {
      $e.addClass("blank");
    }
  });
}
